import {get, post, put} from "$lib/api";

export const getUnit = async (customer:any) => {
    return await get('/customer/' + customer.uuid + '/unit');
}

export const getUnits = async () => {
    return await get('/units');
}

export const getCostCenters = async () => {
    return await get('/cost-centers');
}
export const createCostCenter = async (costCenter:any) => {
    return await post('/cost-center', costCenter);
}

export const updateCostCenter = async (costCenter:any) => {
    return await put('/cost-center/' + costCenter.id, costCenter);
}